import styled from 'styled-components/macro';

export const SocialsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: row;
  `};
`;

export const ComingSoonSocial = styled.div`
  font-family: 'Presicav';
  font-weight: 100;
  font-size: 12px;
  visibility: hidden;
  opacity: 0;
  background-color: #00000050;
  -webkit-backdrop-filter: blur(9.7px);
  backdrop-filter: blur(9.7px);
  white-space: nowrap;
  user-select: none;

  transition: all 0.2s ease-in-out;

  position: absolute;
  top: 45%;
  left: 60px;
  transform: translateY(-50%);
  text-align: center;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 5px 10px 5px 5px;

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-right: 20px solid #333;
    border-color: transparent #00000050 transparent transparent;
  }

  ${({ theme }) => theme.mediaWidth.upToMedium`
      top: -100%;
      left: 0%;
      border-radius: 6px;
      padding: 5px 10px 5px 10px;
      font-size: 11px;

      transform: translateY(-12px) translateX(calc(-50% + 13.5px));
      &:after {
        top: auto;
        bottom: calc(-100% - 13px);
        left: 50%;
        margin-left: -20px;  
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 12px solid #00000050;
      }
  `};
`;

export const SocialDisabledLink = styled.div`
  margin: 10px;
  position: relative;

  ${({ theme }) => theme.mediaWidth.upToMedium`
    flex-direction: column;
  `};

  svg {
    transition: all 0.2s ease-in-out;
  }

  &:hover {
    svg {
      opacity: 0.7;
    }
    ${ComingSoonSocial} {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const SocialLink = styled.a`
  margin: 10px;
  transition: all 0.2s ease-in-out;

  &:hover {
    opacity: 0.7;
  }
`;
